import { api } from '../_client';

export const filesFlightMetaApi = {
  // Update flight metadata
  // Send empty string to clear a field, backend converts to null
  async updateFlightMetadata(
    flightId: string,
    data: {
      pilot_id?: string;
      payload_id?: number;
      customer_id?: string;
      project_id?: string;
      airspace_observer_id?: string;
      payload_operator_id?: string;
      flight_type?: string;
    }
  ): Promise<{ success: boolean; flight: Record<string, unknown> }> {
    const response = await api.patch(`/api/files/flights/${flightId}`, data);
    return response.data;
  },

  // Fetch weather data for a flight
  async fetchFlightWeather(flightId: string): Promise<{
    success: boolean;
    weather: {
      temperature_c: number | null;
      humidity_percent: number | null;
      wind_speed_ms: number | null;
      wind_direction_deg: number | null;
      precipitation_mm: number | null;
      is_raining: boolean | null;
      fetched_at: string | null;
    } | null;
    message?: string;
    error?: string;
  }> {
    const response = await api.post(`/api/files/flights/${flightId}/fetch-weather`);
    return response.data;
  },
};
